import { environment } from './../../environments/environment.prod';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppService<T> {
  constructor(private http: HttpClient) {}

  Get(param: string): Observable<T> {
    return this.http.get<T>(`${environment.urlAPI}${param}`).pipe(take(1));
  }

  // Post(dados: object): Observable<T> {
  //   return this.http.post<T>(`${environment.urlAPI}`, dados).pipe(take(1));
  // }

  Post(dados: FormData): Observable<T> {
    return this.http.post<T>(`${environment.urlAPI}`, dados).pipe(take(1));
  }
}
